import closeQueryInfo from './close-query-info.action';

export default closeQueryInfo;
